export default "__VITE_ASSET__DYC6lgId__"